<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 参展展品卡片 -->
    <div class="page-card">
      <!-- 搜索栏 / 页面头部 -->
      <div class="page-card__header">
        <el-row style="width: 100%">
          <el-col :span="22" style="font-weight: bold; line-height: 32px"> 参展展品</el-col>
          <el-col :span="2" style="text-align: right">
            <el-button round size="small" @click="go_add" type="primary">
              <el-icon class="el-icon-circle-plus-outline"></el-icon>
              添加
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据表格 -->
      <div class="page-card__body">
        <div v-for="i in tableData" v-bind:key="i.id">
          <div style="padding: 20px 0; text-align: left; height: 150px; border-bottom: 1px solid var(--border-color)">
            <el-row>
              <el-col :span="4">
                <el-image
                  @click="goTo_p_detail(i.id)"
                  :src="imgUrl + i.img+'?x-oss-process=image/resize,w_200'" style="width: 150px;height: 150px"
                  fit="cover">
                </el-image>
              </el-col>
              <el-col :span="16">
                <div @click="goTo_p_detail(i.id)" style="padding: 0 16px;height: 190px">
                  <div style="font-weight: bold;height: 40px">
                    {{i.title}}
                  </div>
                  <div style="padding: 10px 0;font-size: 14px;color: var(--text-primary);height: 70px">
                    分类： {{i.type}}
                  </div>
                  <div style="font-size: 14px;height: 20px">
                    <el-row>
                      <el-col :span="12">
                        发布日期：{{i.create_time}}
                      </el-col>
                      <el-col :span="4">
                        浏览量：{{i.view}}

                      </el-col>
                      <el-col :span="4">
                        赞：{{i.praise}}

                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <el-row style="margin: 20px">
                  <el-button round size="small"
                             @click="updateDetail(i.id)" type="primary">修改
                  </el-button>
                </el-row>
                <el-row style="margin: 20px">
                  <el-button round size="small" @click="deteleProduct(i.id)"> 删除</el-button>
                </el-row>
              </el-col>

            </el-row>

          </div>
        </div>
      </div>

      <!-- 分页器 -->
      <div class="pagination-wrap" v-if="tableData.length !== 0">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
      <div v-else style="margin: 20px;line-height: 60px;color: #666666">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {
    name: "productList",
    data() {
      return {
        tableData: [],
        imgUrl: 'https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/product/',
        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,
      }
    },
    mounted() {
      this.datalist()
    },
    methods: {
      /** 获取展品列表 */
      datalist() {
        let id = localStorage.getItem('userid')
        let url = this.baseUrl + '/user/products/?user=' + id;
        api.fetchData(url).then(res => {
          this.tableData = res.results;

          this.aSum = res.count;
          this.currentPage = 1;
        })

      },

      /** 分页切换 */
      handleCurrentChange(val) {
        let id = localStorage.getItem('userid');
        let url = this.baseUrl + '/user/products/?user=' + id + '&page=' + val;
        api.fetchData(url).then(res => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        })

      },

      /** 删除展品 */
      deteleProduct(id) {
        this.$confirm('将删除此条信息，是否继续', '提示', {
          confirmButtonText: "确定",
          cancelButtonText: '取消',
          type: "warning"
        }).then(() => {
          let url = this.baseUrl + '/user/products/' + id + '/';
          api.deleteData(url).then(res => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.datalist()
          })

        })
      },


      /** 跳转到产品详情页 */
      goTo_p_detail(id) {
        this.$router.push({name: "productDetail", query: {type: '1', id: id}})
      },

      /** 跳转到产品添加页 */
      go_add() {
        this.$router.push({name: "productAdd"})
      },
      /** 跳转到产品编辑页 */
      updateDetail(id) {
        this.$router.push({name: "productDetail", query: {type: '2', id: id}})
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/productList.vue